var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeywords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "key-alt-svgrepo-com",
    d: "M15,9h.01M15,15A5.994,5.994,0,1,0,9.054,9.807a3.68,3.68,0,0,1,.068.789A.853.853,0,0,1,9,10.942a2.61,2.61,0,0,1-.426.479L3.469,16.531a2.138,2.138,0,0,0-.321.36,1,1,0,0,0-.12.289A2.139,2.139,0,0,0,3,17.663V19.4a2.484,2.484,0,0,0,.109,1.054,1,1,0,0,0,.437.437A2.484,2.484,0,0,0,4.6,21H6.337a2.142,2.142,0,0,0,.482-.028,1,1,0,0,0,.289-.12,2.139,2.139,0,0,0,.36-.321l5.11-5.111A2.611,2.611,0,0,1,13.058,15a.852.852,0,0,1,.346-.117,3.674,3.674,0,0,1,.789.068A6.051,6.051,0,0,0,15,15Z",
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#97a2b6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeywords);
export default __webpack_public_path__ + "static/media/keywords.3ac4b348ca90c5bc593bb75bf3b72f1a.svg";
export { ForwardRef as ReactComponent };